import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import ConfigStore from '../../Stores/ConfigStore'
import UserInfoView from './Account/UserInfoView'
import { Navbar, Button } from 'react-bootstrap'
import UserStore from '../../Stores/UserStore'

@observer
class HeaderView extends React.Component<any> {
    config = ConfigStore.getInstance()
    us = UserStore.getInstance()
    nav = this.config.nav
    
    toggle() {
        this.config.toggleLeftBar()
    }

    checkHidden(): boolean {
        return this.nav.items.length < 2
    }

    render() {
        return (
            <header
                hidden={'/login' === this.props['location']['pathname']}
            >
                <div className="header">
                    <Navbar>
                        <Navbar.Header>
                            <Navbar.Brand className="d-none d-sm-block">
                                <a href="/"><img src="/images/logo.svg" alt="" /></a>
                            </Navbar.Brand>
                            <Button 
                                className="burgerButton" 
                                onClick={() => { this.toggle() }}
                                hidden={this.checkHidden()}
                            >
                                <img src="images/burger-button.svg" alt=""/>
                            </Button>
                        </Navbar.Header>
                    </Navbar>
                    <UserInfoView />
                </div>
            </header>
        )
    }
}

export default withRouter(HeaderView)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/HeaderView.tsx